import { ChronoUnit, convert, LocalDate, LocalDateTime, LocalTime, nativeJs } from '@js-joda/core';
import { css } from 'styled-components';

import { AvailabilitySimple } from '@dreryk/egabinet-appointment-frontend-api';
import { DoctorSimple } from '@dreryk/egabinet-personnel-frontend-api';

import { SlotLabelStyleConfiguration, TimetableEvent, TimetableSlotSelectionEvent } from '@dreryk/react-calendar';
import { fonts } from '@dreryk/react-components';
import { Range } from '@dreryk/watermelon';

import { WEEK_START_DAY } from './common/common.utils';

const SELECTION_END_TIME = '23:59:59';

export const slotLabelStyleConfiguration: SlotLabelStyleConfiguration<
   'ScheduleTimetableHourLabel' | 'ScheduleTimetableMinuteLabel'
> = {
   slotLabelStyles: [
      {
         styleName: 'ScheduleTimetableHourLabel',
         slotLabelStyleFactory: (defaultThemeProps) => css`
            font-weight: ${fonts.fontWeightNormal};
            color: ${defaultThemeProps.theme.textBody};
         `,
      },
      {
         styleName: 'ScheduleTimetableMinuteLabel',
         slotLabelStyleFactory: (defaultThemeProps) => css`
            font-weight: ${fonts.fontWeightNormal};
            color: ${defaultThemeProps.theme.border};
         `,
      },
   ],
   slotLabelStyleSelector: (slotLabelContent) => {
      if (slotLabelContent.date.getMinutes() === 0) {
         return 'ScheduleTimetableHourLabel';
      }
      return 'ScheduleTimetableMinuteLabel';
   },
};

const convertLocalDateTimeToDate = (localDateTime: LocalDateTime): Date => {
   return convert(localDateTime).toDate();
};

export const convertAvailability = (appointment: AvailabilitySimple): TimetableEvent<AvailabilitySimple> => {
   return {
      id: appointment.id,
      start: convertLocalDateTimeToDate(appointment.availabilityDate.atTime(appointment.startTime)),
      end: convertLocalDateTimeToDate(appointment.availabilityDate.atTime(appointment.endTime)),
      data: appointment,
      resourceId: appointment.practitioner.id.toString(),
   };
};

export const handleSelectionConstraint = (): Range<Date> => {
   return Range.greaterThan(
      convertLocalDateTimeToDate(LocalDateTime.now().with(WEEK_START_DAY).truncatedTo(ChronoUnit.DAYS))
   );
};

const isMidnightNextDay = (startDate: Date, endDate: Date): boolean =>
   LocalDate.from(nativeJs(startDate))
      .plusDays(1)
      .atStartOfDay()
      .isEqual(LocalDateTime.from(nativeJs(endDate)));

export const selectionOnlyWithinOneDay = (selection: TimetableSlotSelectionEvent<DoctorSimple>): boolean => {
   const { start, end } = selection;

   if (isMidnightNextDay(start, end)) {
      return true;
   }

   return (
      start.getFullYear() === end.getFullYear() &&
      start.getMonth() === end.getMonth() &&
      start.getDay() === end.getDay() &&
      !LocalTime.from(nativeJs(end)).isAfter(LocalTime.parse(SELECTION_END_TIME))
   );
};
